import { Check, ChevronLeft, Person } from '@mui/icons-material'
import { SmsStatus } from 'feature/auth/redux/authSlice'
import { FormProvider } from 'react-hook-form'
import { SmsCodeConfirm } from 'widget'
import { UserDataForm } from 'widget/UserDataForm/UserDataForm'

import { useUserEditProfile } from './useUserEditProfile'

// страница настроек пользователя
export function UserEditProfile() {
  const {
    formMethods,
    isLoading,
    isButtonLoading,
    smsInfo,
    userInfo,
    hide,
    setHide,
    onSubmit,
    sendSmsConfirm,
    smsBackHandler,
    handlerGetSms,
    navigate,
  } = useUserEditProfile()

  if (isLoading) return <> </>

  return (
    <FormProvider {...formMethods}>
      <div className='container'>
        {smsInfo.status === SmsStatus.readyForSend && (
          <UserDataForm
            title='Личные данные'
            titleIcon={<Person />}
            sendButton={{
              startIcon: <Check />,
              text: 'Сохранить изменения',
              disabled: true,
              isLoading: isButtonLoading,
            }}
            onSubmit={onSubmit}
            headerButton={{
              text: 'Назад',
              onClick: () => navigate('/settings'),
              startIcon: <ChevronLeft />,
            }}
          />
        )}
        {smsInfo.status !== SmsStatus.readyForSend && (
          <SmsCodeConfirm
            title='Подтверждение изменений'
            onCodeSubmit={sendSmsConfirm}
            startTimerPosition={smsInfo.blockTime}
            backHandler={smsBackHandler}
            phone={userInfo.phone}
            onReRequestSms={handlerGetSms}
            errorText={smsInfo.error}
            onChange={() => {}}
            needHide={hide}
            setNeedHide={setHide}
          />
        )}
      </div>
    </FormProvider>
  )
}
